<template>
  <div class="change-language-page">
    <div class="change-language" @click="() => popupVisible = true ">
      <span class="lang-text"><img class="lang-img" :src="lang"/></span>
      <span v-if="!language" class="placeholer">{{$t('message.selectText')}}</span>
      <span v-else>{{ languageTxt }}</span>
      <i
        :class="
        popupVisible ? 'lang-select-active lang-select-icon' : 'lang-select-icon'
      "
      ></i>
    </div>
    <mt-popup
      position="bottom"
      style="width: 100%"
      v-model="popupVisible"
      popup-transition="popup-fade">
      <div class="btn-groups">
        <span @click="handleCancel">{{$t('message.cancel')}}</span>
        <span @click="handleConfirm">{{$t('message.confirm')}}</span>
      </div>
      <mt-picker class="language-picker" :slots="slots" value-key="text" @change="onValuesChange"></mt-picker>
    </mt-popup>
  </div>
</template>

<script>
import lang from '@/assets/app/lang.png';
import { getLang, setLang } from '@/utils/auth.js';
export default {
  name: 'change-language',
  computed: {
    slots () {
      return [
        {
          values: [{
            text: this.$t('message.zh_CN_text'),
            value: 'zh-CN'
          },
          {
            text: this.$t('message.bo_CN_text'),
            value: 'bo-CN'
          }],
          textAlign: 'center'
        }
      ];
    },
    languageTxt () {
      if (this.language === 'bo-CN') {
        return this.$t('message.bo_CN_text');
      } else {
        return this.$t('message.zh_CN_text');
      }
    }
  },
  data () {
    return {
      lang,
      language: getLang() || 'zh-CN',
      popupVisible: false,
      selectLang: null
    };
  },
  methods: {
    onValuesChange (picker, values) {
      this.selectLang = values[0];
    },
    handleConfirm () {
      this.language = this.selectLang.value;
      this.$i18n.locale = this.selectLang.value;
      setLang(this.selectLang.value);
      this.popupVisible = false;
    },
    handleCancel () {
      this.popupVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.change-language-page {
  .change-language {
    text-align: right;
    position: relative;
    padding-right: 50px;
    .lang-text {
      color: #666;
      font-size: 30px;
      vertical-align: middle;
      .lang-img {
        display: inline-block;
        width: 35px;
        height: 35px;
        padding: 0 5px;
      }
    }
    .placeholer {
      color: #ccc;
    }
    .lang-select-icon {
      position: absolute;
      right: 2.13334vw;
      top: 50%;
      transform: translate(0, -50%);
      border-style: solid;
      border-color: #999 transparent transparent transparent;
      border-width: 1.06666vw 1.06666vw 0 1.06666vw;
      transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
    }
    .lang-select-active {
      transform: translate(0, -50%) rotate(180deg);
    }
  }
  .mint-popup .btn-groups {
    padding: 20px;
    color: #E18605;
    display: flex;
    justify-content: space-between;
  }
}
</style>
